// Import the components of the interface.
import api from './api'
import reducer from './reducers'

/**
 * This interface is for an events plugin.
 * @type {string}
 */
const name = 'events'

export default {
  name,
  api,
  reducer
}
